import React, { PureComponent } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { promisify } from 'app/actions';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { Section, Loader } from 'sa-ui';

import { getEvaluations } from './studentSimulatedActions';

import YearTabs from '../app/common/YearTabs';
import messages from './studentSimulatedMessages';
import SimulatedCard from './SimulatedCard';
import * as helpers from './studentSimulatedHelpers';

import './StudentSimulatedContainer.scss';

class StudentSimulatedContainer extends PureComponent {
  static getDerivedStateFromProps(props, state) {
    if (props.years !== state.prevYears) {
      return {
        params: { ...state.params, year: props.years[0] },
        prevYears: props.years,
      };
    }
    return null;
  }

  state = {
    params: { year: new Date().getFullYear() },
    page: 1,
    limit: 6,
    evaluationsFiltered: [],
    evaluationsPaginated: [],
    isLoading: false,
  };

  async componentDidMount() {
    await this.props.getEvaluations();

    setTimeout(() => {
      const evaluationsFiltered = helpers.filterEvaluations(
        this.props.evaluations,
        this.state.params,
      );
      // const evaluationsFiltered = this.props.evaluations;

      const evaluationsPaginated = helpers.paginate(
        evaluationsFiltered,
        this.state.page,
        this.state.limit,
      );

      this.setState({ evaluationsFiltered, evaluationsPaginated });
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.page !== this.state.page || prevState.params.year !== this.state.params.year) {
      const evaluationsFiltered = helpers.filterEvaluations(
        this.props.evaluations,
        this.state.params,
      );

      // const evaluationsFiltered = this.props.evaluations;

      const evaluationsPaginated = helpers.paginate(
        evaluationsFiltered,
        this.state.page,
        this.state.limit,
      );
      this.setState({ evaluationsFiltered, evaluationsPaginated });
    }
  }

  handleChangeFilter = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;

    if (name === 'page') {
      return this.setState({
        [name]: value,
      });
    }

    if (name === 'year') {
      return this.setState({
        params: {
          ...this.state.params,
          [name]: value,
        },
        page: 1,
      });
    }

    this.setState({
      params: {
        ...this.state.params,
        [name]: value,
      },
    });
  };

  handleChangeState = (name) => (eventOrValue) => {
    const value = eventOrValue.target ? eventOrValue.target.value : eventOrValue;
    this.setState({
      [name]: value,
    });
  };

  render() {
    const { isLoading } = this.props;
    const { evaluationsFiltered, evaluationsPaginated } = this.state;

    return (
      <Section id="student-simulated-container">
        <Loader show={isLoading} />
        <Row className="mb-5">
          <Col>
            <Row>
              <Col>
                <FormattedMessage {...messages.title}>
                  {(txt) => <h1 className="page-title">{txt}</h1>}
                </FormattedMessage>
              </Col>
            </Row>
          </Col>
          <Col>
            <Row className="justify-content-md-end p-0 m-0">{/* <ViewModeSelector /> */}</Row>
          </Col>
        </Row>
        <YearTabs
          year={this.state.params.year}
          years={this.props.years}
          page={this.state.page}
          // pages={Math.ceil((evaluationsFiltered.length + 1) / this.state.limit)}
          pages={Math.ceil(evaluationsFiltered.length / this.state.limit)}
          onChangePage={this.handleChangeFilter('page')}
          onChangeYear={this.handleChangeFilter('year')}
        />
        <Row>
          {evaluationsPaginated.map((d) => (
            <Col key={d.id} className="d-flex" lg={4}>
              <SimulatedCard
                {...d}
                // coordinator={this.props.coordinator}
                style={{ paddingBottom: '15px' }}
                onClick={() => this.props.history.push(`/student-simulated/${d.id}`)}
              />
            </Col>
          ))}
        </Row>
      </Section>
    );
  }
}

StudentSimulatedContainer.defaultProps = {
  evaluations: [],
  years: [new Date().getFullYear()],
};

const mapStateToProps = ({ app, studentSimulated }) => ({
  user: app.user,
  // coordinator: app.coordinator,
  ...studentSimulated,
});

export default compose(
  withRouter,
  injectIntl,
  connect(mapStateToProps, promisify({ getEvaluations })),
)(StudentSimulatedContainer);
